module.exports = __webpack_public_path__ + "static/media/LOCATIONGIF.ff05dc4d.png";